import * as React from 'react';
import { Responsive } from '@cian/ui-kit';
import * as styles from './HeaderLayoutDesktop.css';

export interface IHeaderLayoutDesktopProps {
  chips: React.ReactNode;
  counter: React.ReactNode;
  description: React.ReactNode;
  plate: React.ReactNode;
  searchInput: React.ReactNode;
  sorting: React.ReactNode;
  tags: React.ReactNode;
  title: React.ReactNode;
  promoOffers: React.ReactNode;
  listingsLinks: React.ReactNode;
}

export const HeaderLayoutDesktop: React.FC<IHeaderLayoutDesktopProps> = props => {
  const { chips, counter, description, plate, searchInput, sorting, tags, title, promoOffers, listingsLinks } = props;

  return (
    <div className={styles['container']}>
      <div className={styles['search']}>
        {searchInput}
        {chips}
        {tags}
      </div>
      <div className={styles['promo-offers']}>{promoOffers}</div>
      <div className={styles['category-header']}>
        <div className={styles['title-and-description']}>
          {title}
          {description}
        </div>
        {plate}
        <div className={styles['bottom']}>
          <Responsive desktop>
            <div className={styles['bottom--controls']}>
              {counter}
              {sorting}
            </div>
            <div className={styles['bottom--controls']}>{listingsLinks}</div>
          </Responsive>
          <Responsive tablet>
            {counter}
            {sorting}
          </Responsive>
        </div>
      </div>
    </div>
  );
};
